/** SUNTRONIX ONE — Courier picker.
 *  Reads live from /api/courier-partners/active so any master edit
 *  (activate/deactivate/rename) flows through instantly. Never
 *  hardcode carrier names anywhere else — always use this component.
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function CourierSelect({
  value, onChange, placeholder = "Select courier…",
  className = "h-10 mt-1", testId = "courier-select",
  useBrandCode = false,
}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get("/courier-partners/active")
      .then(({ data }) => {
        if (cancelled) return;
        setItems(data.items || []);
      })
      .catch(() => setItems([]))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  const optionValue = (c) => useBrandCode ? c.code : (c.brand_short || c.name);

  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder={loading ? "Loading couriers…" : placeholder} />
      </SelectTrigger>
      <SelectContent>
        {items.length === 0 && !loading && (
          <div className="px-3 py-2 text-[12px] text-slate-500">
            No active courier partners.
          </div>
        )}
        {items.map((c) => (
          <SelectItem key={c.code} value={optionValue(c)}
            data-testid={`courier-opt-${c.code}`}>
            <div className="flex items-center gap-2">
              <span className="text-[13px]">{c.brand_short || c.name}</span>
              {c.type && (
                <span className="text-[9px] uppercase tracking-wider text-slate-400 px-1 py-0.5 rounded bg-slate-100">
                  {c.type.replace(/_/g, " ")}
                </span>
              )}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
